<template>
  <div class="dialog-margin">
    <div>
      <el-form inline>
        <el-form-item label="销售订单编号">
          <el-input v-model="searchValue.saleOrderNo"/>
        </el-form-item>
        <el-form-item label="物品编号">
          <el-input v-model="searchValue.goodsNo"/>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker v-model="searchValue.orderTimeStart"
                          type="date"
                          placeholder="请选择开始日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"/>
          -
          <el-date-picker v-model="searchValue.orderTimeEnd"
                          type="date"
                          placeholder="请选择结束日期"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item>
          <div class="control-button">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="primary" @click="clearSearch">清空</el-button>
          </div>
        </el-form-item>
      </el-form>
      <el-table :data="orders" :loading="loading" max-height="426px"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"/>
        <el-table-column label="客户名称" prop="custName"/>
        <el-table-column label="销售订单编号" prop="saleOrderNo" width="140"/>
        <el-table-column label="物品编号" prop="goodsNo"/>

        <el-table-column prop="blendName" label="成分"/>
        <el-table-column prop="weight" label="克重"/>
        <el-table-column prop="width" label="幅宽"/>

        <el-table-column prop="mainQuantity" label="订单数量"/>
        <el-table-column prop="mainQuantityUnit" label="数量单位"/>
        <el-table-column prop="contractCount" label="已转化合同数量"/>
        <el-table-column prop="unContractCount" label="订单剩余数量"/>
        <el-table-column prop="placeOrderDate" label="下单时间"/>


      </el-table>
      <div class="control-button padding-10">
        <el-button type="primary" @click="select">选中</el-button>
        <el-button @click="close">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 销售订单选择弹窗
 * @Author: 菩萨蛮
 * @Date: 2021/4/13 11:02 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import qs from 'qs';


export default {
  name: 'SaleOrderSelectDialog',
  props: {
    goodsType: { type: null, default: '成品' },
    currencyUnit: { type: String, default: '人民币' },
    custName: { type: String },
    isSelectedOrder: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      searchValue: {
        saleOrderNo: '',
        goodsNo: '',
        orderTimeStart: null,
        orderTimeEnd: null
      },
      orders: [],
      selectRow: []
    };
  },
  methods: {
    async search() {
      this.loading = true;
      let p = [];
      const { orderTimeStart, orderTimeEnd } = this.searchValue;
      // 随便写的，吃屎去吧
      if (orderTimeStart === null && orderTimeEnd !== null) {
        p = ['1970-01-01', orderTimeEnd];
      }
      if (orderTimeStart !== null && orderTimeEnd !== null) {
        p = [orderTimeStart, orderTimeEnd];
      }
      if (orderTimeStart !== null && orderTimeEnd === null) {
        p = [orderTimeStart, '2099-01-01'];
      }


      const { data } = await this.qGet({
        notEncode: true,
        url: `/sales/sale_order?${qs.stringify({
          status: [2, 3, 4, 5, 6],
          goodsType: this.goodsType,
          currencyUnit: this.currencyUnit,
          custName: this.custName,
          placeOrderDate: p,
          bindContract: true,
          ...this.searchValue
        })}&pageSize=99`
      });
      if (data && data.datas) {
        const list = data.datas.filter(e => !this.isSelectedOrder.includes(e.id));
        this.orders = list.map(e => ({
          ...e,
          ...e.goodsInfo
        }));
      }
      this.loading = false;
    },
    clearSearch() {
      this.searchValue = this.$options.data().searchValue;
    },
    handleSelectionChange(row) {
      this.selectRow = row;
    },
    select() {
      this.$emit('select', this.selectRow);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
